var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "global-footer-copy-notification-block" }, [
      _c("p", { staticClass: "global-footer-copy-notification" }, [
        _vm._v(
          "掲載の情報・画像など、すべてのコンテンツの無断複写、転載を禁じます。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }